



























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Drawer extends Vue {
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  public title!: string;

  @Prop({
    type: String,
    default() {
      return "策略器";
    },
  })
  public noticeMsg!: string;
    
  // 处理关闭提示
  async handleClose() {
    this.$emit('close');
  }
}
